import styled, { css } from 'styled-components';

const Text = styled.div`
  font-family: ${({ theme }) => theme.font.family.websiteMedium};
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #282b32;
  padding: 15px 0 0 0;
  cursor: default;
  word-break: break-word;

  ${({ isList }) =>
    isList &&
    css`
      padding: 3px 0;
    `}
`;

export default Text;
